var _excluded = ["icon", "title", "subtitle"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import * as React from 'react';
import { colors } from '../../@theme/colors';
import Button from '@mui/material/Button';
import { ChevronStyled, BlockButtonContent, TextContainer } from './styles/ButtonBlockStyled';
import { useMediaQuery } from '@mui/material';
var ButtonLink = function ButtonLink(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    subtitle = _ref.subtitle,
    props = _objectWithoutProperties(_ref, _excluded);
  var isMobileDevice = useMediaQuery('(min-width: 769px)');
  var buttonStylesProps = {
    padding: isMobileDevice ? '16px' : '19px 24px',
    minHeight: '74px',
    border: "1px solid ".concat(colors.Neutros20),
    borderRadius: '8px',
    display: 'grid',
    gridAutoFlow: 'column',
    gap: '16px',
    justifyContent: 'space-between',
    textTransform: 'none',
    '&:hover': {
      border: "1px solid ".concat(colors.WomCorp),
      background: 'none'
    }
  };
  return React.createElement(Button, _extends({
    sx: buttonStylesProps,
    variant: "outlined",
    disableRipple: true
  }, props), React.createElement(BlockButtonContent, null, icon, React.createElement(TextContainer, {
    isMobileDevice: isMobileDevice
  }, React.createElement("h3", null, title), subtitle && React.createElement("span", null, subtitle))), React.createElement(ChevronStyled, null));
};
export default ButtonLink;